import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function WishlistSection({ wishlist, removeFromWishlist }) {
  if (wishlist.length === 0) {
    return (
      <div className="text-center py-24" data-testid="no-wishlist">
        <Heart className="h-24 w-24 text-gray-300 mx-auto mb-4" />
        <p className="text-gray-600 text-lg mb-4">Your wishlist is empty</p>
        <Link to="/products" className="inline-block bg-[#1a3a5c] text-white px-6 py-3 rounded-full hover:bg-[#1f4268]">Browse Products</Link>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {wishlist.map((product) => (
        <motion.div key={product.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-testid={`wishlist-item-${product.id}`}>
          <Link to={`/product/${product.id}`}>
            <img src={product.images[0]} alt={product.name} className="w-full h-48 object-cover" />
          </Link>
          <div className="p-4">
            <Link to={`/product/${product.id}`}>
              <h3 className="font-serif text-lg font-semibold text-[#1a3a5c] hover:text-[#C9A967]">{product.name}</h3>
            </Link>
            <p className="text-sm text-gray-600 mb-3">{product.category} • {product.metal_type}</p>
            <div className="flex justify-between items-center">
              <Link to={`/product/${product.id}`} className="text-[#1a3a5c] hover:underline text-sm font-medium">View Details</Link>
              <button onClick={() => removeFromWishlist(product.id)} className="text-red-500 hover:text-red-700 p-2" data-testid={`remove-wishlist-${product.id}`}>
                <Trash2 className="h-5 w-5" />
              </button>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
